(() => {
  const instances = new WeakMap();
  const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const rootsWithin = (container) => {
    const roots = [];
    if (container?.matches?.('[data-dose-directory]')) roots.push(container);
    if (container?.querySelectorAll) roots.push(...container.querySelectorAll('[data-dose-directory]'));
    return roots;
  };
  const initialize = (directory) => {
    if (instances.has(directory)) return;
    const root = directory.closest('[data-armor-dosing-v2][data-display-mode="full"]');
    const search = root?.querySelector('[data-dosing-search]') || directory.querySelector('[data-dose-directory-search]');
    const filters = root?.querySelector('[data-dosing-filters]');
    if (!search) return;
    const groups = [...directory.querySelectorAll('[data-dose-model-group]')];
    const status = directory.querySelector('[data-dose-directory-count]');
    const directoryEmpty = directory.querySelector('[data-dose-directory-empty]');
    const searchWrap = directory.querySelector('[data-dose-directory-search-wrap]');
    const initialGroups = groups.map((group) => ({ group, open: group.open }));
    const controller = new AbortController();
    const { signal } = controller;
    if (root) root.dataset.directoryReady = 'true';
    else searchWrap.hidden = false;
    const entries = groups.map((group) => ({
      group, rows: [...group.querySelectorAll('[data-dose-model]')].map((entry) => ({
        entry, text: normalize(`${entry.dataset.doseModelName} ${entry.dataset.doseTires || ''} ${group.dataset.doseModelGroup}`)
      })), more: group.querySelector('[data-dose-more]'), shown: 12
    }));
    const renderGroup = (state, matches) => {
      state.rows.forEach(({ entry }) => { entry.hidden = true; });
      matches.forEach(({ entry }, index) => { entry.hidden = index >= state.shown; });
      state.more.hidden = matches.length <= state.shown;
      state.more.textContent = `Show ${Math.min(12, Math.max(0, matches.length - state.shown))} more`;
      state.matches = matches;
    };
    const update = () => {
      const terms = search.value.toLowerCase().split(/\s+/).map(normalize).filter(Boolean);
      const active = filters?.querySelector('[aria-pressed="true"]')?.dataset.dosingDevice || 'all';
      const equipment = ['Mobility', 'Golf / utility cart', 'Other equipment'].includes(active);
      const route = equipment ? '/pages/tire-sealant-for-other-pneumatic-tires' : '/pages/find-my-formula';
      root?.querySelector('[data-dosing-empty] [data-dosing-finder-link]')?.setAttribute('href', route);
      directoryEmpty.querySelector('a').setAttribute('href', route);
      let total = 0;
      entries.forEach((state) => {
        const { group } = state;
        const familyMatches = active === 'all' || group.dataset.doseModelGroup === active;
        const matches = state.rows.filter(({ text }) => familyMatches && terms.every(term => text.includes(term)));
        group.hidden = matches.length === 0;
        group.open = matches.length > 0 && (terms.length > 0 || active !== 'all' || initialGroups.find(item => item.group === group).open);
        state.shown = 12;
        renderGroup(state, matches);
        group.querySelector('[data-dose-model-count]').textContent = `${matches.length} models`;
        total += matches.length;
      });
      directoryEmpty.hidden = Boolean(root) || total > 0;
      status.textContent = `${total} ${total === 1 ? 'model' : 'models'}`;
      if (root) {
        directory.hidden = total === 0;
        root.dispatchEvent(new CustomEvent('armor:dosing-directory-updated', { detail: { count: total } }));
      }
    };
    entries.forEach(state => state.more.addEventListener('click', () => {
      const next = state.matches[state.shown]?.entry.querySelector('a');
      state.shown += 12;
      renderGroup(state, state.matches);
      next?.focus();
    }, { signal }));
    const updateAfterClick = () => queueMicrotask(() => { if (!signal.aborted) update(); });
    search.addEventListener('input', update, { signal });
    root?.querySelector('[data-dosing-clear]')?.addEventListener('click', updateAfterClick, { signal });
    filters?.addEventListener('click', updateAfterClick, { signal });
    update();
    instances.set(directory, {
      destroy: () => {
        controller.abort();
        groups.forEach(group => {
          group.hidden = false;
          group.querySelectorAll('[data-dose-model]').forEach(entry => { entry.hidden = false; });
          group.querySelector('[data-dose-more]').hidden = true;
          group.querySelector('[data-dose-model-count]').textContent = `${group.querySelectorAll('[data-dose-model]').length} models`;
        });
        initialGroups.forEach(({ group, open }) => { group.open = open; });
        status.textContent = `${directory.querySelectorAll('[data-dose-model]').length} models`;
        directoryEmpty.hidden = true;
        directory.hidden = false;
        searchWrap.hidden = true;
        if (root) delete root.dataset.directoryReady;
        instances.delete(directory);
      }
    });
  };
  const refresh = container => rootsWithin(container).forEach(initialize);
  const destroy = container => rootsWithin(container).forEach(directory => instances.get(directory)?.destroy());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  else refresh(document);
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
})();
